import { render, staticRenderFns } from "./menuWeb.vue?vue&type=template&id=b331d6e4&"
import script from "./menuWeb.vue?vue&type=script&lang=js&"
export * from "./menuWeb.vue?vue&type=script&lang=js&"
import style0 from "./menuWeb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports